module.exports = __webpack_public_path__ + "media/images/xpass/rewards-fallback-ed23cc26e803ed3d5b1cb6764704fadd.svg";